export interface ChangePartLinkedGroupDetailsDto {
	linkedPartGroupId: number;
	linkedPartGroupProportion: number;
	partId: number;
}

export class ChangePartLinkedGroupDetailsDto implements ChangePartLinkedGroupDetailsDto {
	constructor(data?: Partial<ChangePartLinkedGroupDetailsDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}